import { Component, Input, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'app-email-html-preview',
  standalone: true,
  encapsulation: ViewEncapsulation.ShadowDom,
  template: ` <div class="email ql-editor" [innerHTML]="html"></div> `,
  styleUrl: './email-html-preview.component.scss'
})
export class EmailHtmlPreviewComponent {
  @Input({ required: true }) html: string = '';
}
